import { createContext } from "react";

const BecomeTutorContext = createContext();

export default BecomeTutorContext;
